import { createFileRoute } from '@tanstack/react-router';
import DistributorsPage from '../../views/dashboard-distributors';

export const Route = createFileRoute('/dashboard/distributors/')({
  component: DistributorsPage,
});
